import React from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'
import moment from 'moment-timezone'
import {
  Alert,
  Card,
  Row,
  Col,
  ContentSectionBlock,
  DetailList,
  Link,
  Badge,
  FilterTable,
  PageHeader,
  Button
} from 'camino-react'

import DescriptionPopup from '../PopupWrapper/DescriptionPopup'

import ConvertModal from './ConvertModal'
import { handlers } from './handlers'

import StringManipulator from 'Utilities/StringManipulator'
import TicketCorrespondenceLog from 'Components/Tickets/Correspondence/Log'

class AlertShow extends React.Component {
  constructor (props) {
    super(props)

    const { alert } = this.props
    this.state = {
      ...props,
      selectedAlerts: [alert],
      loading: false,
      fields: {
        assigneeId: null,
        teamId: null,
        problemId: null,
        issue: '',
        priority: null,
        bulkMessage: '',
        queueId: null,
        assignToMe: false,
        title: '',
        description: '',
        ticketId: null,
        contactId: null
      },
      isSourceTheSame: true,
      alertMessage: {
        alertText: '',
        alertType: ''
      }
    }

    this.handlers = handlers.bind(this)
    this.handleFieldValue = this.handlers.handleFieldValue
  }

  render () {
    const {
      alert,
      selectedAlerts,
      loading,
      alertMessage: {
        alertType,
        alertText
      }
    } = this.state

    const {
      handleFieldValue,
      setModal,
      rejectAlerts,
      toggleProblemStatus,
      setTitleAndDescription,
      convertAlerts,
      getTickets,
      handleAssignToMe,
      handleQueue
    } = this.handlers

    const mapAlerts = alerts => _.map(alerts, alert => (
      {
        ...alert,
        description: alert.source_information.description || alert.source_information.message || alert.source_information.Content || alert.source_information.QuantitativeNewState,
        realerted_count: alert.source === 'datto' ? (alert.source_information.triggerCount || 1) : alert.realerted_count,
        first_alerted_at: alert.source === 'datto' ? (alert.source_information.alertTriggered || alert.source_information.lastTriggered) : alert.first_alerted_at,
        last_alerted_at: alert.source === 'datto' ? (alert.source_information.lastTriggered || alert.source_information.alertTriggered) : (alert.source_information.lastDown || alert.last_alerted_at)
      }
    ))

    const badgeColor = ({ alert }) => {
      const { status } = alert

      if (status === 'Pending' || status === 'Converted') {
        return 'orange'
      } if (status === 'Rejected') {
        return 'red'
      } if (status === 'Resolved') {
        return 'green'
      }
    }

    const columns = [
      {
        text: 'Description',
        accessor: 'description',
        defaultWidth: '50',
        Cell: row => (<DescriptionPopup row={row} />)
      },
      {
        text: 'Status',
        accessor: 'status',
        defaultWidth: '50',
        maxWidth: '130'
      },
      {
        text: 'Alerted on',
        accessor: 'last_alerted_at',
        defaultWidth: '50',
        maxWidth: '130',
        Cell: row => (moment(row.value).format('DD MMM YYYY, hh:mmA'))
      }
    ]

    const detailList = [
      {
        title: 'Source',
        content: alert.source
      },
      {
        title: 'Status',
        content: (<Badge color={badgeColor({ alert })}>{alert.status}</Badge>)
      },
      {
        title: 'Affected service',
        content: alert.affectedService
      },
      {
        title: 'Device name',
        content: alert.deviceName
      },
      {
        title: 'Client name',
        content: alert.clientName
      },
      {
        title: 'Priority',
        content: <span style={{ color: alert.priorityColor }}>{alert.priority}</span>
      },
      {
        title: 'Source information',
        content: StringManipulator.simpleFormat(alert.sourceInformation)
      },
      {
        title: 'First alerted at',
        content: moment(alert.first_alerted_at).format('DD MMM YYYY, hh:mmA')
      },
      {
        title: 'Last alerted at',
        content: moment(alert.last_alerted_at).format('DD MMM YYYY, hh:mmA')
      }
    ]

    const relatedAlertsColumns = columns.concat(
      [
        {
          text: 'Affected Service',
          accessor: 'affected_service',
          defaultWidth: '50',
          maxWidth: '130'
        },
        {
          text: 'Client',
          accessor: 'client_name',
          defaultWidth: '50',
          maxWidth: '130'
        }
      ]
    )

    if (alert.ticket) {
      detailList.splice(4, 0, {
        title: 'Associated ticket',
        content: (<Link color="blue" href={alert.ticket.href}>{alert.ticket.id}</Link>)
      })
    }

    if (alert.status === 'Rejected') {
      detailList.push({
        title: 'Rejected by',
        content: alert.rejectedBy
      })

      detailList.push({
        title: 'Rejected at',
        content: moment(alert.rejectedAt).format('DD MMM YYYY, hh:mmA')
      })
    }

    if (alert.status === 'Converted') {
      detailList.push({
        title: 'Converted by',
        content: alert.convertedBy
      })

      detailList.push({
        title: 'Converted at',
        content: moment(alert.convertedAt).format('DD MMM YYYY, hh:mmA')
      })
    }

    if (alert.status === 'Resolved') {
      detailList.push({
        title: 'Resolved by',
        content: alert.resolvedBy
      })

      detailList.push({
        title: 'Resolved at',
        content: moment(alert.resolvedAt).format('DD MMM YYYY, hh:mmA')
      })
    }

    return (
      <>
        <PageHeader
          title={`${alert.deviceName} - ${alert.affectedService}`}
          actions={[
            <Button color="danger" onClick={() => rejectAlerts()} disabled={alert.status !== 'Pending'}>
              Reject
            </Button>,
            <Button
              disabled={alert.status !== 'Pending'}
              onClick={() => {
                setModal('convert')
                handleFieldValue('title', `${_.upperCase(alert.source)} - ${alert.affectedService} - ${alert.deviceName}`)
                handleFieldValue('description', `Created by conversion alerts: ${alert.id}\n${alert.sourceInformation}`)
              }}
            >
              Convert
            </Button>
          ]}
          breadcrumbs={[{ text: 'Alerts', href: '/alerts' }]}
        />
        <Row>
          <Col width={12}>
            {alertText && (
              <Alert type={alertType} title={alertText ? 'Alerts' : ''}>
                {alertText}
              </Alert>
            )}
            <Card>
              <ContentSectionBlock title="Alert details">
                <DetailList list={detailList} />
              </ContentSectionBlock>
              { alert.comments && (
                <ContentSectionBlock title="Realert updates">
                  <TicketCorrespondenceLog comments={alert.comments} />
                </ContentSectionBlock>
              ) }
            </Card>
          </Col>
          <Col width={12}>
            <Card>
              <ContentSectionBlock title="Previous alerts">
                <FilterTable
                  data={mapAlerts(alert.previousAlerts)}
                  columns={columns}
                  localStoragePrefix="PriorAlertsTable"
                  SubComponent={row => (
                    <div style={{ padding: '30px' }}>
                      {row.original.priority && (
                        <div style={{ color: row.original.priorityColor }}>Priority: {row.original.priority}</div>
                      )}
                      {_.map(row.original.source_information, (val, key) => (
                        <div>{_.upperFirst(key)}: {val}</div>
                      ))}
                    </div>
                  )
                  }
                />
              </ContentSectionBlock>
              <ContentSectionBlock title="Related alerts">
                <FilterTable
                  data={mapAlerts(alert.relatedAlerts)}
                  columns={relatedAlertsColumns}
                  localStoragePrefix="RelatedAlertsTable"
                  SubComponent={row => (
                    <div style={{ padding: '30px' }}>
                      {row.original.priority && (
                        <div style={{ color: row.original.priorityColor }}>Priority: {row.original.priority}</div>
                      )}
                      {_.map(row.original.source_information, (val, key) => (
                        <div>{_.upperFirst(key)}: {val}</div>
                      ))}
                    </div>
                  )
                  }
                />
              </ContentSectionBlock>
            </Card>
          </Col>
        </Row>

        <ConvertModal
          {...this.props}
          {...this.state}
          setModal={setModal}
          toggleProblemStatus={value => toggleProblemStatus(value)}
          setTitleAndDescription={() => setTitleAndDescription()}
          rejectAlerts={rejectAlerts}
          convertAlerts={() => convertAlerts()}
          getTickets={value => getTickets(value)}
          handleFieldValue={(field, value) => handleFieldValue(field, value)}
          handleAssignToMe={value => handleAssignToMe(value)}
          handleQueue={value => handleQueue(value)}
          rejectButtonText={loading ? 'Rejecting...' : 'Reject'}
          convertButtonText={loading ? 'Converting...' : 'Convert'}
        />
      </>
    )
  }
}

AlertShow.propTypes = {
  alert: PropTypes.shape({}).isRequired
}

export default AlertShow
